// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== SUGGESTED FEED CONTAINER ==================== */

.uasg-suggested-feed-container {
  position: relative;
  width: 97%;
  height: auto;
  padding: 1rem;
  box-sizing: border-box;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2.5rem;
  border-radius: 10px;
  margin-bottom: 3rem;
  overflow: visible;
  background: var(--card-bg, rgb(4, 4, 4));
  border: 1px solid var(--border-color, rgb(52, 51, 51));
  margin-left: 7px;
}

/* ==================== USER SECTION ==================== */

.uasg-user-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 1rem;
}

/* ==================== USER HEADER SECTION (BLACK BACKGROUND) ==================== */

.uasg-user-header-section {
  width: 100%;
  background: #000;
  border-radius: 10px 10px 0 0;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.1);
}

/* ==================== USER INFO WRAPPER ==================== */

.uasg-user-info-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.uasg-user-avatar-wrapper {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.uasg-user-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

/* ==================== USER NAME ROW ==================== */

.uasg-user-name-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.uasg-user-name-link {
  text-decoration: none;
  color: white;
  transition: color 0.3s ease;
}

.uasg-user-name-link:hover {
  color: #4a9eff;
}

/* ==================== PROFILE BADGE (HIGHLIGHTED) ==================== */

.uasg-profile-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.25), rgba(255, 165, 0, 0.25));
  border: 1.5px solid rgba(255, 215, 0, 0.5);
  border-radius: 20px;
  padding: 0.35rem 1rem;
  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.2);
  transition: all 0.3s ease;
}

.uasg-profile-badge:hover {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.35), rgba(255, 165, 0, 0.35));
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  transform: translateY(-2px);
}

.uasg-profile-link {
  text-decoration: none;
  color: #ffd700;
  font-size: 0.9rem;
  font-weight: 700;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  letter-spacing: 0.5px;
}

/* ==================== POSTS WRAPPER ==================== */

.uasg-posts-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  border-top: none;
}

/* ==================== POST WRAPPER ==================== */

.uasg-post-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  border-radius: 10px;
  overflow: hidden;
}

/* ==================== POST HEADER SECTION (BLACK BACKGROUND) ==================== */

.uasg-post-header-section {
  width: 100%;
  background: none;
  border-radius: 10px 10px 0 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-bottom: none;
}

/* ==================== POST ID ==================== */

.uasg-post-id {
  width: 60%;
}

.uasg-post-id-link {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.uasg-post-id-link:hover {
  color: #ffed4e;
  text-decoration: underline;
}

/* ==================== TIMESTAMP ROW ==================== */

.uasg-timestamp-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.uasg-timestamp {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
}

/* ==================== SUGGESTED FEED CARD ==================== */

.uasg-suggested-feed-card {
  width: 100%;
  height: auto;
  border-radius: 0 0 10px 10px;
  border-top: none;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* ==================== POST DESCRIPTION ==================== */

.uasg-post-description {
  width: 100%;
  margin-left: 15px;
}

.uasg-post-description .text-label {
  color: white;
  line-height: 1.6;
  font-size: 1rem;
}

/* ==================== SUGGESTED FEED MEDIA ==================== */

.uasg-suggested-feed-media {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.uasg-suggested-media-container {
  width: 100%;
  height: auto;
  border-radius: 12px;
  overflow: hidden;
}

.suggested-media-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

/* ==================== POST LOCATION ==================== */

.uasg-post-location {
  width: 100%;
  padding: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 0.5rem;
}

.uasg-location-link {
  color: #4a9eff;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.3s ease;
}

.uasg-location-link:hover {
  color: #74b9ff;
  text-decoration: underline;
}

/* ==================== LOADING & EMPTY STATES ==================== */

.uasg-loading {
  width: 100%;
  padding: 3rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

.uasg-no-posts,
.uasg-no-suggestions {
  width: 100%;
  padding: 2rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

/* ==================== RESPONSIVE: TABLET ==================== */

@media (max-width: 1024px) {
  .uasg-suggested-feed-container {
    padding: 0.75rem;
    gap: 2rem;
  }

  .uasg-user-header-section {
    padding: 0.875rem;
  }

  .uasg-posts-wrapper {
    padding: 0.875rem;
  }

  .uasg-post-header-section {
    padding: 0.875rem;
  }

  .uasg-suggested-feed-card {
    padding: 0.875rem;
  }
}

@media (max-width: 768px) {
  .uasg-suggested-feed-container {
    padding: 0.5rem;
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .uasg-user-header-section {
    padding: 0.75rem;
  }

  .uasg-user-name-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .uasg-profile-badge {
    padding: 0.3rem 0.8rem;
  }

  .uasg-posts-wrapper {
    padding: 0.75rem;
    gap: 1rem;
  }

  .uasg-post-header-section {
    padding: 0.75rem;
  }

  .uasg-suggested-feed-card {
    padding: 0.75rem;
  }

  .uasg-post-id-link {
    font-size: 0.9rem;
  }

  .uasg-timestamp {
    font-size: 0.8rem;
  }

  .uasg-post-description .text-label {
    font-size: 0.9rem;
  }
}

/* ==================== RESPONSIVE: MOBILE ==================== */

@media (max-width: 480px) {
  .uasg-suggested-feed-container {
    padding: 0.5rem;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }

  .uasg-user-section {
    margin-bottom: 0.75rem;
  }

  .uasg-user-header-section {
    padding: 0.5rem;
  }

  .uasg-user-avatar-wrapper {
    width: 40px;
    height: 40px;
  }

  .uasg-user-name-row {
    gap: 0.4rem;
  }

  .uasg-profile-badge {
    padding: 0.25rem 0.6rem;
    font-size: 0.8rem;
  }

  .uasg-posts-wrapper {
    padding: 0.5rem;
    gap: 0.75rem;
  }

  .uasg-post-header-section {
    padding: 0.5rem;
  }

  .uasg-suggested-feed-card {
    padding: 0.5rem;
  }

  .uasg-post-description {
    padding: 0.25rem;
  }

  .uasg-post-description .text-label {
    font-size: 0.85rem;
  }

  .uasg-post-id-link {
    font-size: 0.85rem;
  }

  .uasg-timestamp {
    font-size: 0.75rem;
  }

  .uasg-location-link {
    font-size: 0.85rem;
  }
}

/* ==================== SUGGESTED BY SECTION ==================== */

.uasg-suggested-by-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 4px;
  height: 20px;
}

.uasg-blinking-arrow {
  font-size: 1.5rem;
  color: #ffed4e;
  font-weight: bold;
  animation: blinkArrow 1.5s infinite;
  display: inline-block;
}

@keyframes blinkArrow {
  0%, 100% {
    opacity: 1;
    transform: translateX(0);
  }
  50% {
    opacity: 0.3;
    transform: translateX(-5px);
  }
}

.uasg-suggested-by-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  font-weight: 400;
}

.uasg-suggested-by-link {
  color: #ffed4e;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
}

.uasg-suggested-by-link:hover {
  color: #ffed4e;
  text-decoration: underline;
}

.uasg-suggested-by-link::before {
  content: '@';
  margin-right: 2px;
  opacity: 0.7;
}

/* ==================== RESPONSIVE: TABLET ==================== */

@media (max-width: 1024px) {
  .uasg-suggested-by-wrapper {
    padding: 0.4rem;
  }

  .uasg-blinking-arrow {
    font-size: 1.3rem;
  }

  .uasg-suggested-by-text {
    font-size: 0.85rem;
  }
}

/* ==================== RESPONSIVE: MOBILE ==================== */

@media (max-width: 768px) {
  .uasg-suggested-by-wrapper {
    padding: 0.35rem;
    gap: 0.4rem;
  }

  .uasg-blinking-arrow {
    font-size: 1.2rem;
  }

  .uasg-suggested-by-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .uasg-suggested-by-wrapper {
    flex-direction: row;
    padding: 0.3rem;
    gap: 0.3rem;
  }

  .uasg-blinking-arrow {
    font-size: 1.1rem;
  }

  .uasg-suggested-by-text {
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UASuggestedContent.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;AACrB;;AAEA,qFAAqF;;AAErF;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,4CAA4C;AAC9C;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,0EAA0E;;AAE1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qFAAqF;EACrF,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,qFAAqF;EACrF,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,4DAA4D;;AAE5D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qFAAqF;;AAErF;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA,sDAAsD;;AAEtD;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kEAAkE;;AAElE;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+DAA+D;;AAE/D;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mEAAmE;;AAEnE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4DAA4D;;AAE5D;EACE,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,qEAAqE;;AAErE;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,iEAAiE;;AAEjE;EACE;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iEAAiE;;AAEjE;EACE;IACE,eAAe;IACf,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,2BAA2B;EAC7B;AACF;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA,iEAAiE;;AAEjE;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iEAAiE;;AAEjE;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ==================== SUGGESTED FEED CONTAINER ==================== */\n\n.uasg-suggested-feed-container {\n  position: relative;\n  width: 97%;\n  height: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n  max-width: 1500px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 2.5rem;\n  border-radius: 10px;\n  margin-bottom: 3rem;\n  overflow: visible;\n  background: var(--card-bg, rgb(4, 4, 4));\n  border: 1px solid var(--border-color, rgb(52, 51, 51));\n  margin-left: 7px;\n}\n\n/* ==================== USER SECTION ==================== */\n\n.uasg-user-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-bottom: 1rem;\n}\n\n/* ==================== USER HEADER SECTION (BLACK BACKGROUND) ==================== */\n\n.uasg-user-header-section {\n  width: 100%;\n  background: #000;\n  border-radius: 10px 10px 0 0;\n  padding: 1rem;\n  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.1);\n}\n\n/* ==================== USER INFO WRAPPER ==================== */\n\n.uasg-user-info-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.uasg-user-avatar-wrapper {\n  width: 50px;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.uasg-user-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n/* ==================== USER NAME ROW ==================== */\n\n.uasg-user-name-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.uasg-user-name-link {\n  text-decoration: none;\n  color: white;\n  transition: color 0.3s ease;\n}\n\n.uasg-user-name-link:hover {\n  color: #4a9eff;\n}\n\n/* ==================== PROFILE BADGE (HIGHLIGHTED) ==================== */\n\n.uasg-profile-badge {\n  display: inline-flex;\n  align-items: center;\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.25), rgba(255, 165, 0, 0.25));\n  border: 1.5px solid rgba(255, 215, 0, 0.5);\n  border-radius: 20px;\n  padding: 0.35rem 1rem;\n  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.uasg-profile-badge:hover {\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.35), rgba(255, 165, 0, 0.35));\n  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);\n  transform: translateY(-2px);\n}\n\n.uasg-profile-link {\n  text-decoration: none;\n  color: #ffd700;\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n  letter-spacing: 0.5px;\n}\n\n/* ==================== POSTS WRAPPER ==================== */\n\n.uasg-posts-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 0 0 10px 10px;\n  padding: 1rem;\n  border-top: none;\n}\n\n/* ==================== POST WRAPPER ==================== */\n\n.uasg-post-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* ==================== POST HEADER SECTION (BLACK BACKGROUND) ==================== */\n\n.uasg-post-header-section {\n  width: 100%;\n  background: none;\n  border-radius: 10px 10px 0 0;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  border-bottom: none;\n}\n\n/* ==================== POST ID ==================== */\n\n.uasg-post-id {\n  width: 60%;\n}\n\n.uasg-post-id-link {\n  color: white;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  transition: color 0.3s ease;\n}\n\n.uasg-post-id-link:hover {\n  color: #ffed4e;\n  text-decoration: underline;\n}\n\n/* ==================== TIMESTAMP ROW ==================== */\n\n.uasg-timestamp-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.uasg-timestamp {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n/* ==================== SUGGESTED FEED CARD ==================== */\n\n.uasg-suggested-feed-card {\n  width: 100%;\n  height: auto;\n  border-radius: 0 0 10px 10px;\n  border-top: none;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* ==================== POST DESCRIPTION ==================== */\n\n.uasg-post-description {\n  width: 100%;\n  margin-left: 15px;\n}\n\n.uasg-post-description .text-label {\n  color: white;\n  line-height: 1.6;\n  font-size: 1rem;\n}\n\n/* ==================== SUGGESTED FEED MEDIA ==================== */\n\n.uasg-suggested-feed-media {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.uasg-suggested-media-container {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.suggested-media-img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n/* ==================== POST LOCATION ==================== */\n\n.uasg-post-location {\n  width: 100%;\n  padding: 0.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 0.5rem;\n}\n\n.uasg-location-link {\n  color: #4a9eff;\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.uasg-location-link:hover {\n  color: #74b9ff;\n  text-decoration: underline;\n}\n\n/* ==================== LOADING & EMPTY STATES ==================== */\n\n.uasg-loading {\n  width: 100%;\n  padding: 3rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.uasg-no-posts,\n.uasg-no-suggestions {\n  width: 100%;\n  padding: 2rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n/* ==================== RESPONSIVE: TABLET ==================== */\n\n@media (max-width: 1024px) {\n  .uasg-suggested-feed-container {\n    padding: 0.75rem;\n    gap: 2rem;\n  }\n\n  .uasg-user-header-section {\n    padding: 0.875rem;\n  }\n\n  .uasg-posts-wrapper {\n    padding: 0.875rem;\n  }\n\n  .uasg-post-header-section {\n    padding: 0.875rem;\n  }\n\n  .uasg-suggested-feed-card {\n    padding: 0.875rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .uasg-suggested-feed-container {\n    padding: 0.5rem;\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n  }\n\n  .uasg-user-header-section {\n    padding: 0.75rem;\n  }\n\n  .uasg-user-name-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .uasg-profile-badge {\n    padding: 0.3rem 0.8rem;\n  }\n\n  .uasg-posts-wrapper {\n    padding: 0.75rem;\n    gap: 1rem;\n  }\n\n  .uasg-post-header-section {\n    padding: 0.75rem;\n  }\n\n  .uasg-suggested-feed-card {\n    padding: 0.75rem;\n  }\n\n  .uasg-post-id-link {\n    font-size: 0.9rem;\n  }\n\n  .uasg-timestamp {\n    font-size: 0.8rem;\n  }\n\n  .uasg-post-description .text-label {\n    font-size: 0.9rem;\n  }\n}\n\n/* ==================== RESPONSIVE: MOBILE ==================== */\n\n@media (max-width: 480px) {\n  .uasg-suggested-feed-container {\n    padding: 0.5rem;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .uasg-user-section {\n    margin-bottom: 0.75rem;\n  }\n\n  .uasg-user-header-section {\n    padding: 0.5rem;\n  }\n\n  .uasg-user-avatar-wrapper {\n    width: 40px;\n    height: 40px;\n  }\n\n  .uasg-user-name-row {\n    gap: 0.4rem;\n  }\n\n  .uasg-profile-badge {\n    padding: 0.25rem 0.6rem;\n    font-size: 0.8rem;\n  }\n\n  .uasg-posts-wrapper {\n    padding: 0.5rem;\n    gap: 0.75rem;\n  }\n\n  .uasg-post-header-section {\n    padding: 0.5rem;\n  }\n\n  .uasg-suggested-feed-card {\n    padding: 0.5rem;\n  }\n\n  .uasg-post-description {\n    padding: 0.25rem;\n  }\n\n  .uasg-post-description .text-label {\n    font-size: 0.85rem;\n  }\n\n  .uasg-post-id-link {\n    font-size: 0.85rem;\n  }\n\n  .uasg-timestamp {\n    font-size: 0.75rem;\n  }\n\n  .uasg-location-link {\n    font-size: 0.85rem;\n  }\n}\n\n/* ==================== SUGGESTED BY SECTION ==================== */\n\n.uasg-suggested-by-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  border-radius: 4px;\n  height: 20px;\n}\n\n.uasg-blinking-arrow {\n  font-size: 1.5rem;\n  color: #ffed4e;\n  font-weight: bold;\n  animation: blinkArrow 1.5s infinite;\n  display: inline-block;\n}\n\n@keyframes blinkArrow {\n  0%, 100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  50% {\n    opacity: 0.3;\n    transform: translateX(-5px);\n  }\n}\n\n.uasg-suggested-by-text {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n  font-weight: 400;\n}\n\n.uasg-suggested-by-link {\n  color: #ffed4e;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.uasg-suggested-by-link:hover {\n  color: #ffed4e;\n  text-decoration: underline;\n}\n\n.uasg-suggested-by-link::before {\n  content: '@';\n  margin-right: 2px;\n  opacity: 0.7;\n}\n\n/* ==================== RESPONSIVE: TABLET ==================== */\n\n@media (max-width: 1024px) {\n  .uasg-suggested-by-wrapper {\n    padding: 0.4rem;\n  }\n\n  .uasg-blinking-arrow {\n    font-size: 1.3rem;\n  }\n\n  .uasg-suggested-by-text {\n    font-size: 0.85rem;\n  }\n}\n\n/* ==================== RESPONSIVE: MOBILE ==================== */\n\n@media (max-width: 768px) {\n  .uasg-suggested-by-wrapper {\n    padding: 0.35rem;\n    gap: 0.4rem;\n  }\n\n  .uasg-blinking-arrow {\n    font-size: 1.2rem;\n  }\n\n  .uasg-suggested-by-text {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .uasg-suggested-by-wrapper {\n    flex-direction: row;\n    padding: 0.3rem;\n    gap: 0.3rem;\n  }\n\n  .uasg-blinking-arrow {\n    font-size: 1.1rem;\n  }\n\n  .uasg-suggested-by-text {\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
